var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-white font-bold py-2 px-4 border-b-4 rounded",class:{
    'bg-gray-500 border-gray-700 cursor-not-allowed	':
      _vm.disabled,
    'bg-purple-500 hover:bg-purple-400 border-purple-700 hover:border-purple-500':
      !_vm.disabled && _vm.buttonColor === 'purple',
    'bg-green-500 hover:bg-green-400 border-green-700 hover:border-green-500':
      !_vm.disabled && _vm.buttonColor === 'green',
    'bg-red-500 hover:bg-red-400 border-red-700 hover:border-red-500':
      !_vm.disabled && _vm.buttonColor === 'red',
    'bg-yellow-500 hover:bg-yellow-400 border-yellow-700 hover:border-yellow-500':
      !_vm.disabled && _vm.buttonColor === 'yellow',
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('on-clicked')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }